import React, { Component } from "react";
import { Button, Table, Grid, Segment, Tab } from "semantic-ui-react";

import moment from "moment";
import find from "lodash/find";
import constants from "../../constants";

const _ = { find };
const breakdownOfFees = constants.breakdownOfFees;
const tuitionFeeSched = constants.tuitionFeeSched;

export class Confirm extends Component {
  continue = (e) => {
    e.preventDefault();
    // PROCESS FORM //
    this.handleSubmit();
    this.props.nextStep();
  };

  back = (e) => {
    e.preventDefault();
    this.props.prevStep();
  };

  handleSubmit = () => {
    const { values, applicationType, enrollmentFile } = this.props;

    const data = {
      firstName: values.firstName,
      middleName: values.middleName,
      lastName: values.lastName,
      extensionName: values.extensionName,
      birthDate: values.birthDate,
      gender: values.gender,
      address: values.address,
      nickName: values.nickName,
      email: values.email,
      lrn: values.lrn,
      studentNumber: values.studentNumber,
      religion: values.religion,
      placeOfBirth: values.placeOfBirth,
      mobile1: values.mobile1,
      mobile2: values.mobile2,
      contactPerson: values.contactPerson,
      contactPersonNumber: values.contactPersonNumber,
      contactPersonAddress: values.contactPersonAddress,
      guardianName: values.guardianName,
      guardianNumber: values.guardianNumber,
      guardianAddress: values.guardianAddress,
      guardianOccupation: values.guardianOccupation,
      guardianOfficeAddress: values.guardianOfficeAddress,
      beenHospitalized: values.beenHospitalized,
      hospitalReason: values.hospitalReason,
      medicalHistory: values.medicalHistory,
      prevSchoolName: values.prevSchoolName,
      prevSchoolAddress: values.prevSchoolAddress,
      // file: enrollmentFile,
      filename: enrollmentFile ? enrollmentFile.name : null,
      gradeFilename: values.gradeFilename,
      gradeLevel: values.gradeLevel,
      paymentSchedule: values.paymentSchedule,
      applicationType,
      mother: values.mother,
      father: values.father,
      motherReason: values.motherReason,
      ethnicity: values.ethnicity,
      motherTounge: values.motherTounge,
      languages: values.languages,
      //TO-DO: Change this soon.. apply nextSchoolYear field
      schoolYearId: "09b42d95-fb0a-48ad-bb87-e261744c7a0e",
    };
    this.props.handleSubmit(data);
  };

  render() {
    const { values } = this.props;

    let breakdownLevel, scheduleOfPayment, ue, amt;
    if (values.gradeLevel) {
      breakdownLevel = _.find(breakdownOfFees, {
        gradeLevel: values.gradeLevel,
      });
    }

    if (values.paymentSchedule) {
      scheduleOfPayment = _.find(tuitionFeeSched, {
        gradeLevel: values.gradeLevel,
      });

      if (values.paymentSchedule === "Full Cash Basis") {
        ue = scheduleOfPayment.cash;
        amt = "";
      } else if (values.paymentSchedule === "Semi-Annual") {
        ue = scheduleOfPayment.uponEnrollmentSemi;
        amt = scheduleOfPayment.semi;
      } else if (values.paymentSchedule === "Quarterly") {
        ue = scheduleOfPayment.uponEnrollmentQuarterly;
        amt = scheduleOfPayment.quarterly;
      } else if (values.paymentSchedule === "Monthly Basis") {
        ue = scheduleOfPayment.uponEnrollmentMonthlyPlusBooks;
        amt = scheduleOfPayment.monthly;
      } else {
        ue = "";
        amt = "";
      }
    }

    const panes = [
      {
        menuItem: "Personal Information",
        render: () => (
          <Tab.Pane>
            <Table basic="very" celled size="small">
              <Table.Body>
                <Table.Row>
                  <Table.Cell collapsing>
                    <strong>Name</strong>
                  </Table.Cell>
                  <Table.Cell>
                    <span>
                      {values.lastName}, {values.firstName} {values.middleName}
                    </span>
                  </Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell collapsing>
                    <strong>Gender</strong>
                  </Table.Cell>
                  <Table.Cell>{values.gender}</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell collapsing>
                    <strong>Place of Birth</strong>
                  </Table.Cell>
                  <Table.Cell>{values.placeOfBirth}</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell collapsing>
                    <strong>Birthdate</strong>
                  </Table.Cell>
                  <Table.Cell>
                    {moment(values.birthDate).format("MMM DD, YYYY")}
                  </Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell collapsing>
                    <strong>Religion</strong>
                  </Table.Cell>
                  <Table.Cell>{values.religion}</Table.Cell>
                </Table.Row>
              </Table.Body>
            </Table>
          </Tab.Pane>
        ),
      },
      {
        menuItem: "Contact Details",
        render: () => (
          <Tab.Pane>
            <h3>Personal Contact Information</h3>
            <Table basic="very" celled size="small">
              <Table.Body>
                <Table.Row>
                  <Table.Cell collapsing>
                    <strong>Address</strong>
                  </Table.Cell>
                  <Table.Cell>{values.address}</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell collapsing>
                    <strong>Email</strong>
                  </Table.Cell>
                  <Table.Cell>{values.email}</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell collapsing>
                    <strong>Mobile 1</strong>
                  </Table.Cell>
                  <Table.Cell>{values.mobile1}</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell collapsing>
                    <strong>Mobile 2</strong>
                  </Table.Cell>
                  <Table.Cell>{values.mobile2}</Table.Cell>
                </Table.Row>
              </Table.Body>
            </Table>
            <h3>Contact Information in case of Emergency</h3>
            <Table basic="very" celled size="small">
              <Table.Body>
                <Table.Row>
                  <Table.Cell collapsing>
                    <strong>Contact Person</strong>
                  </Table.Cell>
                  <Table.Cell>{values.contactPerson}</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell collapsing>
                    <strong>Contact Person Number</strong>
                  </Table.Cell>
                  <Table.Cell>{values.contactPersonNumber}</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell collapsing>
                    <strong>Contact Person Address</strong>
                  </Table.Cell>
                  <Table.Cell>{values.contactPersonAddress}</Table.Cell>
                </Table.Row>
              </Table.Body>
            </Table>
          </Tab.Pane>
        ),
      },
      {
        menuItem: "Other Details",
        render: () => (
          <Tab.Pane>
            <h4>Parents</h4>
            <Table basic="very" celled size="small">
              <Table.Body>
                <Table.Row>
                  <Table.Cell collapsing>
                    <strong>Mother's Maiden Name</strong>
                  </Table.Cell>
                  <Table.Cell>{values.mother}</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell collapsing>
                    <strong>Father's Name</strong>
                  </Table.Cell>
                  <Table.Cell>{values.father}</Table.Cell>
                </Table.Row>
              </Table.Body>
            </Table>
            <h4>Guardian</h4>
            <Table basic="very" celled size="small">
              <Table.Body>
                <Table.Row>
                  <Table.Cell collapsing>
                    <strong>Name</strong>
                  </Table.Cell>
                  <Table.Cell>{values.guardianName}</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell collapsing>
                    <strong>Contact Number</strong>
                  </Table.Cell>
                  <Table.Cell>{values.guardianNumber}</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell collapsing>
                    <strong>Address</strong>
                  </Table.Cell>
                  <Table.Cell>{values.guardianAddress}</Table.Cell>
                </Table.Row>
              </Table.Body>
            </Table>
            <h4>Others</h4>
            <Table basic="very" celled size="small">
              <Table.Body>
                <Table.Row>
                  <Table.Cell collapsing>
                    <strong>Ethnicity</strong>
                  </Table.Cell>
                  <Table.Cell>{values.ethnicity}</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell collapsing>
                    <strong>Mother Tounge</strong>
                  </Table.Cell>
                  <Table.Cell>{values.motherTounge}</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell collapsing>
                    <strong>Other Spoken Languages</strong>
                  </Table.Cell>
                  <Table.Cell>{values.languages}</Table.Cell>
                </Table.Row>
              </Table.Body>
            </Table>
          </Tab.Pane>
        ),
      },
      {
        menuItem: "Medical",
        render: () => (
          <Tab.Pane>
            <Table basic="very" celled size="small">
              <Table.Body>
                <Table.Row>
                  <Table.Cell collapsing>
                    <strong>Have Been Hospitalized?</strong>
                  </Table.Cell>
                  <Table.Cell>
                    {values.beenHospitalized ? "Yes" : "No"}
                  </Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell collapsing>
                    <strong>Reason</strong>
                  </Table.Cell>
                  <Table.Cell>{values.hospitalReason}</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell collapsing>
                    <strong>Medical History</strong>
                  </Table.Cell>
                  <Table.Cell>{values.medicalHistory}</Table.Cell>
                </Table.Row>
              </Table.Body>
            </Table>
          </Tab.Pane>
        ),
      },
      {
        menuItem: "Enrollment Information",
        render: () => (
          <Tab.Pane>
            <Table basic="very" celled size="small">
              <Table.Body>
                {this.props.applicationType === "new" && (
                  <>
                    <Table.Row>
                      <Table.Cell collapsing>
                        <strong>Previous School Name</strong>
                      </Table.Cell>
                      <Table.Cell>{values.prevSchoolName}</Table.Cell>
                    </Table.Row>
                    <Table.Row>
                      <Table.Cell collapsing>
                        <strong>Previous School Address</strong>
                      </Table.Cell>
                      <Table.Cell>{values.prevSchoolAddress}</Table.Cell>
                    </Table.Row>
                    <Table.Row>
                      <Table.Cell collapsing>
                        <strong>Form 137(Report Card)</strong>
                      </Table.Cell>
                      <Table.Cell>{values.gradeFilename}</Table.Cell>
                    </Table.Row>
                  </>
                )}

                <Table.Row>
                  <Table.Cell collapsing>
                    <strong>Grade Level</strong>
                  </Table.Cell>
                  <Table.Cell>{values.gradeLevel}</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell collapsing>
                    <strong>Payment Schedule</strong>
                  </Table.Cell>
                  <Table.Cell>{values.paymentSchedule}</Table.Cell>
                </Table.Row>
              </Table.Body>
            </Table>
            <div style={{ marginBottom: "14px" }}>
              <span>Breakdown of Fees</span>
              <Table unstackable celled size="small">
                <Table.Header>
                  <Table.Row>
                    <Table.HeaderCell>LEVEL</Table.HeaderCell>
                    <Table.HeaderCell>TUITION FEES</Table.HeaderCell>
                    <Table.HeaderCell>MISC FEES</Table.HeaderCell>
                    <Table.HeaderCell>BOOKS & MAGAZINES</Table.HeaderCell>
                    <Table.HeaderCell>TOTAL</Table.HeaderCell>
                    <Table.HeaderCell>SUBSIDY</Table.HeaderCell>
                    <Table.HeaderCell>TOTAL (TF, MISC, BOOKS)</Table.HeaderCell>
                  </Table.Row>
                </Table.Header>

                <Table.Body>
                  <Table.Row>
                    <Table.Cell>{breakdownLevel.gradeLevel}</Table.Cell>
                    <Table.Cell textAlign="right">
                      {breakdownLevel.tuition}
                    </Table.Cell>
                    <Table.Cell textAlign="right">
                      {breakdownLevel.misc}
                    </Table.Cell>
                    <Table.Cell textAlign="right">
                      {breakdownLevel.books}
                    </Table.Cell>
                    <Table.Cell textAlign="right">
                      {breakdownLevel.total}
                    </Table.Cell>
                    <Table.Cell textAlign="right" color="green">
                      {breakdownLevel.subsidy}
                    </Table.Cell>
                    <Table.Cell textAlign="right">
                      <strong>{breakdownLevel.grandTotal}</strong>
                    </Table.Cell>
                  </Table.Row>
                </Table.Body>
              </Table>
            </div>
            <div style={{ marginBottom: "14px" }}>
              <span>Payment Schedule</span>
              <Table unstackable celled size="small">
                <Table.Header>
                  <Table.Row>
                    <Table.HeaderCell>LEVEL</Table.HeaderCell>
                    <Table.HeaderCell>PAYMENT SCHEDULE</Table.HeaderCell>
                    <Table.HeaderCell>UPON ENROLLMENT</Table.HeaderCell>
                    <Table.HeaderCell>NEXT PAYMENT</Table.HeaderCell>
                  </Table.Row>
                </Table.Header>

                <Table.Body>
                  <Table.Row>
                    <Table.Cell>{scheduleOfPayment.gradeLevel}</Table.Cell>
                    <Table.Cell textAlign="right">
                      {values.paymentSchedule}
                    </Table.Cell>
                    <Table.Cell textAlign="right">{ue}</Table.Cell>
                    <Table.Cell textAlign="right">{amt}</Table.Cell>
                  </Table.Row>
                </Table.Body>
              </Table>
            </div>
            <span>
              {" "}
              NOTE: Subsidies, vouchers, and other grants are not yet included
              in this computation. Your actual computation will be sent to you
              after the assessment.
            </span>
          </Tab.Pane>
        ),
      },
    ];
    return (
      <Segment className="enrollment-form-segment">
        <div className="student-name-div">
          <span className="student-name">
            {values.lastName}, {values.firstName} ({values.nickName})
          </span>
          <span className="student-lrn">Applicant #: {values.appNumber} </span>{" "}
          <br />
          <span className="student-lrn">
            LRN: {values.lrn ? values.lrn : "--"}{" "}
          </span>
        </div>
        <Tab style={{ marginBottom: "14px" }} panes={panes} />

        <Grid>
          <Grid.Column width={8}></Grid.Column>
          <Grid.Column width={8} textAlign="right">
            <Button onClick={this.back}>Back</Button>
            <Button onClick={this.continue}>Continue</Button>
          </Grid.Column>
        </Grid>
      </Segment>
    );
  }
}

export default Confirm;
